// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"k1-z","dimensionLabel":"l1-z","styleChooserControlWrapper":"m1-z","styleChooserControl":"n1-z","disabled":"o1-z","giftCard":"p1-z","styleChooserText":"q1-z"};